import { Context } from '@vue-storefront/core';

import useCartStorage from './useCartStorage';
import { BuyerIdentity } from '@api-client/src/types';

export interface LoadCartProps {
  context: Context;
  buyer: BuyerIdentity | null;
  customVariables?: Record<string, unknown>;
}

const loadCart = async ({ context, buyer, customVariables }: LoadCartProps) => {
  const { getCartIdFromStorage, removeCartIdFromStorage, saveCartIdToStorage } =
    useCartStorage(context);

  const existingCartId = getCartIdFromStorage();

  if (existingCartId) {
    try {
      const cart = await context.$shopify.api.getCart({
        id: existingCartId,
      });

      return cart;
    } catch (e) {
      removeCartIdFromStorage();
    }
  }

  const cart = await context.$shopify.api.cartCreate({
    input: {
      buyerIdentity: buyer,
      ...customVariables,
    },
  });

  saveCartIdToStorage(cart.id);

  return cart;
};

export default loadCart;
